import RequiredSelection from '@/app/massive_download/models/RequiredSelection'

class MassiveDownload {
  constructor ({ requiredSelection, columnSelection, filterSelection }) {
    this.requiredSelection = new RequiredSelection(requiredSelection)
    this.columnSelection = columnSelection
    this.filterSelection = filterSelection
  }
}

export default MassiveDownload



// WEBPACK FOOTER //
// ./src/app/massive_download/models/MassiveDownload.js